<template>
  <div style="background-color: white;">
    <!-- Header con la barra de navegación -->
    <div style="height: 60px; background-color: white; border-bottom: thin solid #E3E5EB"
         class="d-flex align-center">
      <div class="d-flex align-center mx-auto" style="width: 100%; height: 60px;">
        <!-- Logo y Brand -->
        <div class="d-flex align-center justify-space-between px-4 py-2" style="height: 57px !important;">
          <router-link to="/app" class="d-flex align-center text-decoration-none brand-link">
            <h1 style="color: #4dd453; font-size: 1.7rem; letter-spacing: -0.02; font-weight: 900 !important;" 
                class="mb-1 font-rubik">
              <span>SeleAI</span>
            </h1>
          </router-link>
        </div>

        <v-spacer></v-spacer>
        <!-- Botón de volver a la app -->
        <v-btn class="mr-4 subscribe-btn font-rubik" height="44" depressed to="/app">
          Volver a la aplicación
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ml-2 lucide lucide-arrow-left">
            <path d="m12 19-7-7 7-7"/><path d="M19 12H5"/>
          </svg>
        </v-btn>
      </div>
    </div>

    <!-- Hero Section -->
    <div style="background-color: #f8f9fd; padding-top: 80px; padding-bottom: 80px;" class="hero-section">
      <v-container>
        <v-row>
          <v-col cols="12" md="6" class="d-flex flex-column justify-center">
            <h1 class="font-rubik font-weight-bold" style="font-size: 3rem !important; line-height: 1.2 !important;">
              ⚡ Mejora tus calificaciones con Premium
            </h1>
            <p class="font-rubik mt-4 font-weight-medium" style="font-size: 1.25rem !important; color: #5A6159 !important; max-width: 500px;">
              Desbloquea todas las funciones y mejora tu rendimiento académico sin distracciones.
            </p>
            <p class="font-rubik mt-2 font-weight-medium" style="font-size: 1rem !important; color: #5A6159 !important; max-width: 500px;">
              Ayúdanos a continuar ofreciendo contenido de calidad año tras año.
            </p>
            <v-btn color="primary" x-large class="mt-6 premium-btn font-rubik" width="200" to="#planes">
              Ver planes
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ml-2 lucide lucide-arrow-down">
                <path d="M12 5v14M5 12l7 7 7-7"/>
              </svg>
            </v-btn>
          </v-col>
          <v-col cols="12" md="6" class="d-flex justify-center align-center">
            <v-img src="https://sele.ai:3334/api/images/other/premium_hero.png" max-width="500"></v-img>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <!-- Sección de Planes de Precios -->
    <div id="planes" style="padding-top: 80px; padding-bottom: 80px;">
        <h2 class="font-rubik text-center font-weight-bold mb-8" style="font-size: 2.5rem;">
          Elige el plan perfecto para ti
        </h2>
        
        <!-- Componente de Pricing Section -->
        <pricing-section :is-start-plan="false"></pricing-section>
    </div>

    <!-- Sección de Características -->
    <div style="background-color: #f8f9fd; padding-top: 80px; padding-bottom: 80px;">
      <v-container>
        <h2 class="font-rubik text-center font-weight-bold mb-12" style="font-size: 2.5rem;">
          ¿Por qué elegir Premium?
        </h2>
        
        <v-row>
          <v-col cols="12" md="4" class="pa-4">
            <v-card class="h-100 rounded-lg" flat>
              <v-card-text class="d-flex flex-column align-center text-center pa-6">
                <v-avatar color="#E3F5E4" size="80" class="mb-6">
                  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#4dd453" stroke-width="2" stroke-linecap="round" 
                  style="max-width: 40px; max-height: 40px;"
                  stroke-linejoin="round" class="lucide lucide-upload rounded-0">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                    <polyline points="17 8 12 3 7 8"/>
                    <line x1="12" x2="12" y1="3" y2="15"/>
                  </svg>
                </v-avatar>
                <h3 class="font-rubik font-weight-bold mb-4" style="font-size: 1.5rem;">
                  Subidas ilimitadas
                </h3>
                <p class="font-rubik" style="color: #5A6159;">
                  Sube todos tus documentos y materiales de estudio sin restricciones.
                </p>
              </v-card-text>
            </v-card>
          </v-col>
          
          <v-col cols="12" md="4" class="pa-4">
            <v-card class="h-100 rounded-lg" flat>
              <v-card-text class="d-flex flex-column align-center text-center pa-6">
                <v-avatar color="#E3F5E4" size="80" class="mb-6">
                  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#4dd453" stroke-width="2"
                  style="max-width: 40px; max-height: 40px;"
                  stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-book rounded-0">
                    <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"/>
                  </svg>
                </v-avatar>
                <h3 class="font-rubik font-weight-bold mb-4" style="font-size: 1.5rem;">
                  Cuestionarios avanzados
                </h3>
                <p class="font-rubik" style="color: #5A6159;">
                  Accede a cuestionarios con explicaciones detalladas y tipos avanzados de preguntas.
                </p>
              </v-card-text>
            </v-card>
          </v-col>
          
          <v-col cols="12" md="4" class="pa-4">
            <v-card class="h-100 rounded-lg" flat>
              <v-card-text class="d-flex flex-column align-center text-center pa-6">
                <v-avatar color="#E3F5E4" size="80" class="mb-6">
                  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#4dd453" stroke-width="2" stroke-linecap="round" 
                  style="max-width: 40px; max-height: 40px;"
                  stroke-linejoin="round" class="lucide lucide-users rounded-0">
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
                    <circle cx="9" cy="7" r="4"/>
                    <path d="M22 21v-2a4 4 0 0 0-3-3.87"/>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                  </svg>
                </v-avatar>
                <h3 class="font-rubik font-weight-bold mb-4" style="font-size: 1.5rem;">
                  Recursos de la comunidad
                </h3>
                <p class="font-rubik" style="color: #5A6159;">
                  Accede a todos los recursos compartidos por la comunidad de estudiantes.
                </p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <!-- Testimonios -->
    <div style="padding-top: 80px; padding-bottom: 80px;">
      <v-container>
        <h2 class="font-rubik text-center font-weight-bold mb-12" style="font-size: 2.5rem;">
          Lo que dicen nuestros usuarios
        </h2>
        
        <v-row>
          <v-col cols="12" md="4" class="pa-4">
            <v-card class="h-100 rounded-lg" outlined>
              <v-card-text class="pa-6">
                <div class="d-flex mb-4">
                  <v-avatar size="48" class="mr-4">
                    <v-img src="https://sele.ai:3334/api/images/other/avatar1.png"></v-img>
                  </v-avatar>
                  <div>
                    <h4 class="font-rubik font-weight-bold mb-1">Laura Martínez</h4>
                    <div class="d-flex">
                      <v-icon color="#FFD700" small v-for="n in 5" :key="n">mdi-star</v-icon>
                    </div>
                  </div>
                </div>
                <p class="font-rubik" style="color: #5A6159;">
                  "Gracias a Premium he podido mejorar mis notas en selectividad. Los cuestionarios avanzados son increíbles."
                </p>
              </v-card-text>
            </v-card>
          </v-col>
          
          <v-col cols="12" md="4" class="pa-4">
            <v-card class="h-100 rounded-lg" outlined>
              <v-card-text class="pa-6">
                <div class="d-flex mb-4">
                  <v-avatar size="48" class="mr-4">
                    <v-img src="https://sele.ai:3334/api/images/other/avatar2.png"></v-img>
                  </v-avatar>
                  <div>
                    <h4 class="font-rubik font-weight-bold mb-1">Carlos Rodríguez</h4>
                    <div class="d-flex">
                      <v-icon color="#FFD700" small v-for="n in 5" :key="n">mdi-star</v-icon>
                    </div>
                  </div>
                </div>
                <p class="font-rubik" style="color: #5A6159;">
                  "Los recursos de la comunidad me han ayudado muchísimo. Vale la pena cada euro invertido en esta plataforma."
                </p>
              </v-card-text>
            </v-card>
          </v-col>
          
          <v-col cols="12" md="4" class="pa-4">
            <v-card class="h-100 rounded-lg" outlined>
              <v-card-text class="pa-6">
                <div class="d-flex mb-4">
                  <v-avatar size="48" class="mr-4">
                    <v-img src="https://sele.ai:3334/api/images/other/avatar3.png"></v-img>
                  </v-avatar>
                  <div>
                    <h4 class="font-rubik font-weight-bold mb-1">Marina López</h4>
                    <div class="d-flex">
                      <v-icon color="#FFD700" small v-for="n in 5" :key="n">mdi-star</v-icon>
                    </div>
                  </div>
                </div>
                <p class="font-rubik" style="color: #5A6159;">
                  "La posibilidad de subir apuntess ilimitados ha sido clave para mi éxito en los exámenes."
                </p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <!-- Preguntas Frecuentes -->
    <div style="background-color: #f8f9fd; padding-top: 80px; padding-bottom: 80px;">
      <v-container>
        <h2 class="font-rubik text-center font-weight-bold mb-12" style="font-size: 2.5rem;">
          Preguntas Frecuentes
        </h2>
        
        <preguntes-frequents></preguntes-frequents>
      </v-container>
    </div>

    <!-- Call To Action -->
    <div
    v-if="false"
    style="padding-top: 80px; padding-bottom: 80px; background-color: #740AFF;">
      <v-container class="text-center">
        <h2 class="font-rubik font-weight-bold white--text mb-6" style="font-size: 2.5rem;">
          No pierdas el tiempo
        </h2>
        <h3 class="font-rubik font-weight-bold white--text mb-8" style="font-size: 1.5rem;">
          Hazte Premium hoy mismo
        </h3>
        
        <pricing-section :is-start-plan="true"></pricing-section>
      </v-container>
    </div>

    <!-- Footer con métodos de pago -->
    <v-sheet color="#F8F9FD" height="150" class="d-flex align-center pr-12">
      <v-spacer></v-spacer>
      <v-img src="https://sele.ai:3334/api/images/other/stripe-payments.png"
             max-width="400"
             max-height="50"
             contain
      ></v-img>
    </v-sheet>
  </div>
</template>

<script>
import PreguntesFrequents from "./components/PreguntesFrequents.vue";
import PricingSection from "../../components/pricing/PricingSection.vue";

export default {
  name: "PremiumPage",
  components: {
    PreguntesFrequents,
    PricingSection
  },
  data() {
    return {
      starsIntersecting: false,
    }
  },
  computed: {
    nextYear() {
      const d1 = new Date();
      let year = d1.getFullYear();
      let month = d1.getMonth() + 1;
      if (month >= 9) year++;
      return year;
    }
  },
}
</script>

<style scoped>
.hero-section {
  position: relative;
  background-color: white;
  background-attachment: scroll;
  background-position: 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  font-family: "Nunito", "DINRounded", "Inter", sans-serif !important;
  font-weight: 700;
  color: #333;
  /* background-color: #e6f7e8; */
  background: linear-gradient(to bottom, #e6f7e8, white) !important;
  /* background-image: radial-gradient(#b9e9b4 1px, #e6f7e8 0.5px); */
  background-size: 20px 20px;
  background-repeat: repeat;
}

.premium-btn {
  position: relative;
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  letter-spacing: -0.01em !important;
  box-shadow: 0 3px 0 #58a700 !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
  overflow: hidden;
  height: 50px !important;
  transform: translateY(0) !important;
  background: linear-gradient(90deg, #4dd453, #58cc02) !important;
}

.premium-btn:hover {
  filter: brightness(1.05);
  box-shadow: 0 4px 0 #58a700 !important;
  transform: translateY(-1px) !important;
}

.premium-btn:active {
  box-shadow: 0 0 0 #58a700 !important;
  transform: translateY(4px) !important;
}

.subscribe-btn {
  position: relative;
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  letter-spacing: -0.01em !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
  overflow: hidden;
  height: 39px !important;
  transform: translateY(0) !important;
  background: #29544D !important;
  box-shadow: 0 3px 0 #1F3F3A !important;
  color: white !important;
}

.subscribe-btn:hover {
  filter: brightness(1.05);
  box-shadow: 0 4px 0 #1F3F3A !important;
  transform: translateY(-1px) !important;
}

.subscribe-btn:active {
  box-shadow: 0 0 0 #1F3F3A !important;
  transform: translateY(4px) !important;
}

.font-rubik {
  font-family: 'Rubik', sans-serif !important;
}

.roll-in-right {
  -webkit-animation: roll-in-right 0.6s ease-out both;
  animation: roll-in-right 0.6s ease-out both;
}

@-webkit-keyframes roll-in-right {
  0% {
    -webkit-transform: translateX(800px) rotate(540deg);
    transform: translateX(800px) rotate(540deg);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0) rotate(0deg);
    transform: translateX(0) rotate(0deg);
    opacity: 1;
  }
}

@keyframes roll-in-right {
  0% {
    -webkit-transform: translateX(800px) rotate(540deg);
    transform: translateX(800px) rotate(540deg);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0) rotate(0deg);
    transform: translateX(0) rotate(0deg);
    opacity: 1;
  }
}
</style>
